'use client';

import { useTranslations } from 'next-intl';

import { RevealBatch } from '@/components/flagship/page/RevealBatch';
import { ArticleType } from '@/lib/api/article-api';

import ArticleCard from '../article-card';

function ArticleRelatedPost({
  article,
  articles,
}: {
  article: ArticleType;
  articles: ArticleType[];
}) {
  const t = useTranslations('Article');

  const related = articles
    .filter(
      (item) =>
        item.id !== article.id &&
        item.tags &&
        item.tags.some((tag) => article.tags.includes(tag))
    )
    // The old version rendered every match into a `col-md-6` grid that no
    // longer exists; four is what the two-column layout actually holds.
    .slice(0, 4);

  if (related.length === 0) return null;

  return (
    <section className="mt-20">
      <div className="fg-hairline mb-8 h-px" />
      <h2 className="fg-display fg-ink mb-8 text-2xl">{t('relatedArticles')}</h2>

      <RevealBatch className="grid grid-cols-1 gap-5 sm:grid-cols-2">
        {related.map((item) => (
          <div data-reveal key={item.id} className="h-full">
            <ArticleCard articleItem={item} />
          </div>
        ))}
      </RevealBatch>
    </section>
  );
}

export default ArticleRelatedPost;
